import { useAuthBearerFetch } from "matsuri-hooks"
import { m2mCleaning_cleanerV4 } from "@/endpoints/m2m-cleaning.cleaner-v4"
import { ListingOccupancy } from "@/model/listingOccupancy"

export type ListingOccupancyByOperationIdsOutput = Record<
    string, // operationId
    ListingOccupancy | undefined
>

export const useListingOccupancyByOperationIds = (
    token: string,
    operationIds: string[]
) => {
    const endpoint = m2mCleaning_cleanerV4.listListingOccupancyByCleaningIds
    return useAuthBearerFetch<ListingOccupancyByOperationIdsOutput>(
        token,
        operationIds.length > 0 ? endpoint() : null,
        {
            method: endpoint.method,
            body: JSON.stringify({ cleaningIds: operationIds })
        }
    )
}
